/**
 * Controller: pricingCategoriesCreateModal
 */
angular.module('acme.view.application.pricing.categories.createModal.controllers', [
  'acme.common.service.validate'
])

.controller('PricingCategoriesCreateModalController', [ 
  '$scope', 'pricingCategory', 'childrenGrid', 'admissionTypes', 'comboGridShown', 'childQuantities', 'admissionStatus', '$uibModalInstance', 'ValidateService',
  function($scope, pricingCategory, childrenGrid, admissionTypes, comboGridShown, childQuantities, admissionStatus, $uibModalInstance, ValidateService) {

  $scope.pricingCategoriesCreateModal = {

    model: {},
    childrenGrid: {},
    admissionTypes: [],
    comboGridShown: false,
    childQuantities : [],
    admissionStatus: 'active',
    isSubmitted: false,
    title: 'Add',
    isEditMode: false,

    init: function() {
      var self = $scope.pricingCategoriesCreateModal;

      self.model = pricingCategory;
      self.childrenGrid = childrenGrid;
      self.admissionTypes = admissionTypes;
      self.comboGridShown = comboGridShown;
      self.childQuantities = childQuantities;
      self.admissionStatus = admissionStatus;

      if (self.model.name) {
        self.title = 'Edit';
        self.isEditMode = true;
      }
    },

    showComboGrid: function() {
      return this.model.type === 'Combo';
    },

    validate: function() {
      return ValidateService.validate([{ len: { value: $scope.pricingCategoriesCreateModal.model.name } }]);
    },

    isValidName: function() {
      var r = true;

      if (this.isSubmitted) {
        r = ValidateService.validate([
          { len: { value: $scope.pricingCategoriesCreateModal.model.name } }
        ]);
      }

      return r;
    },

    close: function () {
      $uibModalInstance.dismiss('cancel');
    },

    save: function() {
      var self = $scope.pricingCategoriesCreateModal;
      self.isSubmitted = true;
      if (self.validate()) {
        this.model.active = (this.admissionStatus === 'active');
        self.done();
      } else {
        console.log('con error');
      }
    },

    done: function () {
      $uibModalInstance.close($scope.pricingCategoriesCreateModal.model);
    }

  };

  $scope.pricingCategoriesCreateModal.init();  

}]);

